import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Endpoints } from "../../Global/Endpoints";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const WelcomeKit = ({nextStep, prevStep, handleChange, formData, isLastStep, isSubmitting, error, setErrors, step, totalSteps, isHighmarkPortal}) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(formData.addressOption || "");
  const [updatedAddress, setUpdatedAddress] = useState(formData.WinCentiveAddress || "");
  const [address, setAddress] = useState("");
  const [enrolled, setEnrolled] = useState(formData.enrolled || null);
  const [loading, setLoading] = useState(true);
  const contract = useSelector((state) => state.userData);
  const token = localStorage.getItem("AccessToken");

  useEffect(() => {
    const fetchEnrollmentData = async () => {
      setLoading(true);
      const params = {
        memberID: contract.userData.MemberID,
        firstName: contract.userData.FirstName,
        dob: contract.userData.DOB,
        EmailID: contract.userData.EmailID,
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        contract: contract.userData.ContractIdentified || "",
        lastName: contract.userData.LastName,
      };
      try {
        const response = await axios.post(
          Endpoints.VerifyWINcentiveWelcomeBoxAddress,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { enrolled, address } = response.data;
        setEnrolled(enrolled);
        handleChange({ target: { name: "enrolled", value: enrolled } });
        if (enrolled === "Y") {
          setAddress(address);
        }
      } catch (error) {
        console.error("Error fetching enrollment data:", error);
        setEnrolled("N");
        handleChange({ target: { name: "enrolled", value: "N" } });
      } finally {
        setLoading(false);
      }
    };

    fetchEnrollmentData();
  }, []);

  useEffect(() => {
    if (formData.WinCentiveAddress) {
      setUpdatedAddress(formData.WinCentiveAddress);
    }
    if (formData.addressOption) {
      setSelectedOption(formData.addressOption);
    }
  }, [formData]);

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.addressOption;

      if (selectedValue === "No" && !updatedAddress.trim()) {
        updatedErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
      }
      return updatedErrors;
    });

    if (selectedValue === "Yes") {
      setUpdatedAddress("");
      handleChange({ target: { name: "WinCentivekit", value: "Y" } });
      handleChange({ target: { name: "WinCentiveAddress", value: address || "" } });
    } else if (selectedValue === "No") {
      setUpdatedAddress("");
      handleChange({ target: { name: "WinCentivekit", value: "Y" } });
      handleChange({ target: { name: "WinCentiveAddress", value: "" } });
    } else if (selectedValue === "Later") {
      setUpdatedAddress("");
      handleChange({ target: { name: "WinCentivekit", value: "N" } });
      handleChange({ target: { name: "WinCentiveAddress", value: "" } });
    }

    handleChange({ target: { name: "addressOption", value: selectedValue || "" } });
  };

  const handleAddressChange = (e) => {
    const updatedValue = e.target.value;
    if (updatedValue.length === 1 && updatedValue.trim() === "") {
      return;
    }
    setUpdatedAddress(updatedValue);
    handleChange({ target: { name: "WinCentiveAddress", value: updatedValue } });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (selectedOption === "No" && !updatedValue.trim()) {
        updatedErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
      } else {
        delete updatedErrors.WinCentiveAddress;
      }
      return updatedErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!selectedOption) {
      newErrors.addressOption = "Please select an address option.";
    }

    if (selectedOption === "No" && !updatedAddress.trim()) {
      newErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
    }

    setErrors(prev => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      nextStep();
    }
  };

  if (loading) {
    return <div className="welcome-kit-section">Loading...</div>;
  }

  // If not enrolled, skip this step
  if (enrolled !== "Y") {
    nextStep();
    return null;
  }

  return (
    <div className="welcome-kit-section">
      <div className="mt-4">
        <p><strong className="text-primary-color">Welcome to WINMaternity!</strong> We would love to send you gift some goodies for your pregnancy journey as well as a smart blood pressure cuff that you can sync up with your WINFamily app to keep in touch with your health.</p>

        <p>{t("adresstitle")}</p>
        <p><strong>{address}</strong></p>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            id="optionYes"
            name="addressOption"
            value="Yes"
            className="form-check-input radio-btn win-form-check-input"
            onChange={handleOptionChange}
            checked={selectedOption === "Yes"}
          />
          <label className="multistep-form-radio-checkbox-label" htmlFor="optionYes">
            {t("yesradio")}
          </label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            id="optionNo"
            name="addressOption"
            value="No"
            className="form-check-input radio-btn win-form-check-input"
            onChange={handleOptionChange}
            checked={selectedOption === "No"}
          />
          <label className="multistep-form-radio-checkbox-label" htmlFor="optionNo">
            {t("noradio")}
          </label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            id="optionLater"
            name="addressOption"
            value="Later"
            className="form-check-input radio-btn win-form-check-input"
            onChange={handleOptionChange}
            checked={selectedOption === "Later"}
          />
          <label className="multistep-form-radio-checkbox-label" htmlFor="optionLater">
            {t("noneradio")}
          </label>
        </div>

        {selectedOption === "No" && (
          <div className="mt-3">
            <label className="form-label" htmlFor="updatedAddress">
              {t("updatedAddress")}
            </label>
            <textarea
              id="updatedAddress"
              className="win-form-control textarea-control-w-100"
              rows="3"
              maxLength={250}
              value={updatedAddress}
              onChange={handleAddressChange}
            />

              {!updatedAddress && error && <p className="text-danger">{"Address is required if 'No' is selected."}</p>}
          </div>
        )}
        {!selectedOption && error && (
          <p className="text-danger">{"Please select an address option."}</p>
        )}
      </div>

      <div className="mt-5 mb-5">
        {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            <button className="previous-btn" onClick={prevStep}></button>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={handleNext}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>{t('back')}</button>
            <button className="win-btn-primary mobile-view" onClick={handleNext}>{t('next')}</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default WelcomeKit;
